import {IBaseDialogProps} from "../../base";
import React from "react";

export interface IWrappedDialogProps {
    props: Omit<IBaseDialogProps, 'open'>;
    Component: React.ReactNode;
}

export interface ICommonDialogContextProps {
    //support
    openModal?: ((props: IWrappedDialogProps) => void) | undefined;
    closeModal?: (() => void) | undefined;

    //provider
    showDialog?: (props: IWrappedDialogProps) => void;
    hideDialog?: () => void;
    showError?: (err: Error) => void;
    hideError?: () => void;
}


class DialogManager {

    private dialogContext: ICommonDialogContextProps;

    constructor(dialogContext: ICommonDialogContextProps) {
        this.dialogContext = dialogContext;
    }

    open(props: IWrappedDialogProps) {
        console.log("Dialog Manager open called. this.dialogContext=", this.dialogContext);
        if(this.dialogContext.openModal) {
            console.log("openModal called");
            this.dialogContext.openModal(props);
        } else if(this.dialogContext.showDialog) {
            console.log("showDialog called");
            this.dialogContext.showDialog(props);
        } else {
            console.log("Nothing called");
        }
    }

    close() {
        if(this.dialogContext.closeModal) {
            console.log("closeModal called");
            this.dialogContext.closeModal();
        } else if(this.dialogContext.hideDialog) {
            console.log("hideDialog called");
            this.dialogContext.hideDialog();
        } else {
            console.log("Nothing called");
        }
    }
}

export default DialogManager;